export const Condition = [
    {
        label: "Okay",
        value: "Okay"
    },
    {
        label: "Not Okay",
        value: "Not Okay"
    }
]
export const serviceRequestType = [
    {
        label: "Instant",
        value: "Instant"
    },
    {
        label: "Scheduled",
        value: "Scheduled"
    }
]

export const serviceType = [
    {
        label: "Service",
        value: "Service"
    },
    {
        label: "Spare",
        value: "Spare"
    }
]

export const approvalAmounts = [
    {
        label: '0 - 100,000',
        value: 100_000
    },
    {
        label: '100,001 - 1,000,000',
        value: 1_000_000
    },
    {
        label: '1,000,001 and above',
        value: 10_000_000
    },
    // {
    //     label: '5,000,001 - 10,000,000',
    //     value: 10_000_000
    // },
    // {
    //     label: '10,000,001 and above',
    //     value: 10_000_001
    // }
]